<btn
    [id]="id()"
    [label]="label()"
    [severity]="severity()"
    [size]="size()"
    [outlined]="true"
    [text]="text()"
    [disabled]="disabled()"
    (onClick)="onClick.emit($event)"></btn>
